<template>
  <div class="company-switcher__search">
    <label class="company-switcher__search-field">
      <lucide-icon
        :icon="icons.search"
        :size="16"
        aria-hidden="true"
        class="company-switcher__search-icon"
      />
      <input
        ref="input"
        :value="value"
        type="text"
        role="combobox"
        autocomplete="off"
        aria-autocomplete="list"
        aria-expanded="true"
        :aria-controls="listboxId"
        :aria-activedescendant="activeOptionId"
        :aria-label="$t('buscarempresa')"
        :placeholder="$t('buscarempresa')"
        class="company-switcher__search-input"
        @input="$emit('input', $event.target.value)"
      />
    </label>
  </div>
</template>

<script>
import { Search } from 'lucide'
import LucideIcon from '@/components/LucideIcon'

export default {
  name: 'CompanySwitcherSearchField',
  components: { LucideIcon },
  props: {
    value: {
      type: String,
      required: true
    },
    listboxId: {
      type: String,
      required: true
    },
    activeOptionId: {
      type: String,
      default: null
    }
  },
  computed: {
    icons() {
      return { search: Search }
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    }
  }
}
</script>
